module.exports = __webpack_public_path__ + "static/logo-19c45b54ea2ea470a51d3a3397d376b8.svg";